import React from 'react'

import { bemJoin, classNames } from '@app/lib/bem'

import './index.scss'

export interface EventBoxProps {
  icon: React.ReactNode
  heading: string
  subheading: string
  color?: 'warning' | 'neutral' | 'success' | 'danger' | 'info' | 'secondary'
}

const EventBox = ({ icon, heading, subheading, color = 'neutral' }: EventBoxProps) => {
  const b = bemJoin('event-box')

  return (
    <div className={b()}>
      <div className={classNames(b('icon-container'), b({ [color]: true }))}>
        <div className={b('icon')}>{icon}</div>
      </div>

      <div className={b('content')}>
        <span className={b('heading')}>{heading}</span>
        <span className={b('subheading')}>{subheading}</span>
      </div>
    </div>
  )
}

export default EventBox
